import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';
import { deleteSupplement } from '@redux/modules/listing';
import { SortableHandle } from 'react-sortable-hoc';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import SupplementComboBox from './components/SupplementComboBox';
import SupplementDescription from './components/SupplementDescription';
import SupplementLink from './components/SupplementLink';

const DragHandle = SortableHandle(() => <i className="fas fa-grip-vertical mr-3" style={{ cursor: 'move' }} />);

const SupplementCard = ({ file, sortIndex }) => {
  const dispatch = useDispatch();
  const { values, setValues } = useFormikContext();

  const handleDelete = () => {
    // flips isDeleted flag in Redux store
    dispatch(deleteSupplement(file.uid));

    // set formik state for deleted supplement
    setValues({
      ...values,
      Supplements: {
        ...values.Supplements,
        [file.uid]: {
          ...file,
          IsDeleted: true,
        },
      },
    });
  };

  return (
    <>
      <Card id={file.uid} className="mb-g">
        <Card.Header className="pr-3 d-flex align-items-center flex-wrap">
          <div className="card-title">
            <DragHandle />
            {sortIndex + 1}
          </div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-delete-supplement-${file.uid}`} style={{ margin: 0 }}>Delete Supplement</Tooltip>}
          >
            <Button
              name="btnDeleteSupplement"
              onClick={handleDelete}
              className="ml-auto"
              size="sm"
            >
              <i className="far fa-trash-alt" aria-hidden="true" />
            </Button>
          </OverlayTrigger>
        </Card.Header>
        <Card.Body>
          <SupplementComboBox uid={file.uid} supplementType={file.SupplementType} />
          <SupplementDescription uid={file.uid} />
          <SupplementLink
            path={file.Path}
            mediaType={file.MediaType}
            url={file.URL}
          />
        </Card.Body>
      </Card>
    </>
  );
};

SupplementCard.propTypes = {
  file: PropTypes.shape({
    Path: PropTypes.string,
    Name: PropTypes.string,
    Description: PropTypes.string,
    UniqueID: PropTypes.number,
    SupplementType: PropTypes.string,
    MediaType: PropTypes.string,
    IsDeleted: PropTypes.bool,
    IsLive: PropTypes.bool,
    IsPreload: PropTypes.bool,
    URL: PropTypes.string,
    uid: PropTypes.string,
  }),
  sortIndex: PropTypes.number.isRequired,
};

export default SupplementCard;
